import {
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
} from '@angular/core';

import { Editor, Toolbar } from 'ngx-editor';
import DOMPurify from 'dompurify';
import { LinkifyPipe } from '../../linkify.pipe';

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.css'],
})
export class TextEditorComponent implements OnInit {
  editor: Editor | undefined;
  @Input() html = '';

  @Output() htmlChange = new EventEmitter<string>();

  toolbar: Toolbar = [
    ['bold', 'underline', 'italic'],
    ['ordered_list', 'bullet_list'],
    ['link'],
  ];

  constructor(
    public zone: NgZone,
    private linkifyPipe: LinkifyPipe,
  ) {}

  ngOnInit(): void {
    this.editor = new Editor({
      keyboardShortcuts: true,
    });
  }

  ngOnDestroy(): void {
    this.editor?.destroy();
  }

  decodeHTMLEntities(html: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }

  onContentChange(value: string) {
    // Remove images but don't sanitize or linkify during editing
    // This prevents interference with the editor's formatting state
    const decoded = this.decodeHTMLEntities(value);
    const withoutImages = decoded.replace(/<img[^>]*>/gi, '');

    this.htmlChange.emit(withoutImages);
  }

  // Call this method to get sanitized and linkified content for saving
  getSanitizedAndLinkifiedContent(): string {
    const decoded = this.decodeHTMLEntities(this.html);
    const withoutImages = decoded.replace(/<img[^>]*>/gi, '');

    // Apply linkify to convert plain URLs to anchor tags
    const linkified = this.linkifyPipe.transform(withoutImages);

    const sanitized = DOMPurify.sanitize(linkified, {
      ALLOWED_TAGS: [
        'p',
        'b',
        'i',
        'u',
        'a',
        'ul',
        'ol',
        'li',
        'br',
        'strong',
        'em',
      ],
      ALLOWED_ATTR: ['href', 'target'],
      FORBID_TAGS: ['script', 'iframe', 'img'],
      FORBID_ATTR: ['onerror', 'onclick', 'onload'],
    });

    return sanitized;
  }
}
